<template>
  <vs-row vs-w="12">
    <vs-col vs-lg="5" vs-sm="12">
      <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <img v-if="selectedItem" class="itemImage"
             :src="$root.imagePath + selectedItem.ItemFileName"
             alt="Image">
      </vs-row>
      <vs-row v-if="selectedItem" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"
              style="position: relative;">
        <vs-chip color="lightgreen" style="position: absolute; top: -15px; color:forestgreen;"><strong>
          <animated-number :duration="300" :formatValue="formatToPrice" :value="getPrice(selectedItem)"/>
        </strong></vs-chip>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-input-number min="1" max="9999" v-model="quantity" label="Mennyiség:"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" style="margin-bottom: 10px;">
          <vs-button :disabled="isNaN(parseInt(quantity)) || parseInt(quantity) <= 0 || parseInt(quantity) > 9999" @click="addToCart()">Hozzáadás</vs-button>
        </vs-row>
      </vs-row>
    </vs-col>
    <vs-col vs-w="7">
      <div v-if="selectedItem">
        <vs-row>
          <h3>{{ selectedItem.ItemName }}</h3>
        </vs-row>
        <vs-row class="itemDesc">{{ selectedItem.ItemDescription }}</vs-row>
        <vs-row class="itemLabels" v-if="selectedItem.ItemLabels && selectedItem.ItemLabels.length > 0">
          <vs-chip color="success" v-for="(label, index) in selectedItem.ItemLabels" :key="index">
            {{ label.LabelName }}
          </vs-chip>
        </vs-row>
        <vs-row class="itemAddons" v-if="selectedItem.ItemAddons && selectedItem.ItemAddons.length > 0">
          <vs-row>
            <h5>Választható extrák:</h5>
          </vs-row>
          <span style="margin-top: 10px;" v-for="(addon, index) in selectedItem.ItemAddons" :key="index">
        <vs-checkbox v-model="selectedAddons" :vs-value="addon">
          {{ addon.AddonName }} ({{ addon.AddonPrice }} HUF)
        </vs-checkbox>
          </span>
        </vs-row>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>

import AnimatedNumber from "animated-number-vue";

export default {
  name: "add_to_cart",
  props: ['selectedItem'],
  components: {
    AnimatedNumber
  },
  data() {
    return {
      quantity: 1,
      selectedAddons: []
    }
  },
  watch: {
    selectedItem() {
      this.quantity = 1;
    }
  },
  methods: {
    formatToPrice(value) {
      return `${Number(value).toFixed(0)} HUF`;
    },
    addToCart() {
      let payload = {};
      payload.MenuId = this.selectedItem.ItemMenu.MenuId;
      payload.ItemId = this.selectedItem.ItemId ? this.selectedItem.ItemId : this.selectedItem.Id;
      payload.ItemName = this.selectedItem.ItemName;
      // DP: elmentjük a kategóriát és a menüt
      payload.ItemCategoryName=this.selectedItem.ItemCategory == null ? "" : this.selectedItem.ItemCategory.CategoryName;
      payload.MenuName = this.selectedItem.ItemMenu.MenuName;
      payload.ParentId = this.selectedItem.ParentId;
      payload.ItemQty = isNaN(parseInt(this.quantity)) || parseInt(this.quantity) <= 0 || parseInt(this.quantity) > 9999 ? 1 : this.quantity;
      payload.ItemPrice = this.selectedItem.ItemPrice;
      payload.ItemAddons = this.selectedAddons;
      this.quantity = 1;
      this.selectedAddons = [];
      this.$parent.$emit("addToCartEvent", payload);
    },
    getPrice(item) {
      let sum = 0;
      if (this.selectedAddons && this.selectedAddons.length > 0) {
        sum += this.selectedAddons.reduce((elem, {AddonPrice}) => elem + parseInt(AddonPrice), 0);
      }

      return (parseInt(item.ItemPrice) + sum) * this.quantity;
    },
  }
}
</script>

<style scoped>

.vs-input-number {
  margin: 15px 0;
}

.itemImage {
  height: 150px;
  border-radius: 5px;
  max-width: 100%;
}

.itemDesc, .itemLabels, .itemAddons {
  margin: 10px 0;
}

button {
  margin-top: 10px;
}
</style>